import { Reveal, Eyebrow } from "@/components/Reveal";
import { useSite } from "@/lib/content";

export default function TechSection() {
  const { data } = useSite();
  const categories = data?.settings?.techCategories || [];

  return (
    <section className="relative overflow-hidden border-y border-slate-800/60 bg-navy py-28 sm:py-36" data-testid="technology-section">
      <div className="bg-grid absolute inset-0 opacity-50 [mask-image:radial-gradient(ellipse_at_30%_40%,black_20%,transparent_75%)]" />
      <div className="relative mx-auto max-w-7xl px-6 lg:px-10">
        <Reveal>
          <Eyebrow>Technology</Eyebrow>
          <h2 className="mt-4 max-w-2xl font-display text-2xl font-semibold tracking-tight text-white sm:text-3xl lg:text-4xl">
            The disciplines behind dependable software.
          </h2>
          <p className="mt-4 max-w-2xl text-base leading-relaxed text-slate-400">
            We choose technology based on what your solution needs — not trends.
            These are the disciplines we work across every day.
          </p>
        </Reveal>

        <div className="mt-14 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {categories.map((cat, i) => (
            <Reveal key={cat.name} delay={i * 0.05} y={16}>
              <div
                className="group h-full rounded-xl border border-slate-800/80 bg-void/60 px-6 py-5 transition-[border-color,background-color] duration-300 hover:border-blue-500/40 hover:bg-void"
                data-testid={`tech-category-${i}`}
              >
                <div className="flex items-center gap-3">
                  <span className="h-1.5 w-1.5 rounded-full bg-gradient-to-r from-blue-500 to-cyan-400" />
                  <h3 className="font-display text-sm font-semibold text-slate-100">{cat.name}</h3>
                </div>
                <div className="mt-4 flex flex-wrap gap-2">
                  {cat.items.map((item) => (
                    <span
                      key={item}
                      className="rounded-full border border-slate-800 bg-slate-900/60 px-3 py-1 text-xs text-slate-400 transition-colors duration-300 group-hover:border-slate-700"
                    >
                      {item}
                    </span>
                  ))}
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
